import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    users: [],
}
const mutations = {
    nothing(){},

    user_list(state , users){
        Vue.set(state, 'users', users);
        Vue.set(state, 'users', [...users]);
    },

    add_user(state, user){
        state.users.unshift(user)
    },

    edit_user(state, payload){
        const item = state.users.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_user(state, id){
        const itemIndex = state.users.findIndex(item => item.id === id);
        state.users.splice(itemIndex , 1);
    },

}
const actions = {
    getUsers({ dispatch, commit }, info){
        let query = ''
        if(info.title != ''){
            query = `/${info.title}`
        }
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/users/p${query}?page=${info.page}`, method: 'GET' })
            .then(res => {
                commit('user_list', res.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    getAllUsers({ dispatch, commit }, page=1){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/users?page=${page}`, method: 'GET' })
            .then(res => {
                commit('user_list', res.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },


    addUser({ commit }, user) {
        return new Promise((resolve, reject) => {
          axios({ url: `${mainurl}/api/admin/newUser`, data: user, method: 'POST' })
            .then(res => {
              commit("add_user", res.data.data)
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      },

    getUserInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/user/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateUserInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/editUser/${payload.id}`, data: payload, method: 'POST' })
            .then(res => {
                commit('edit_user', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deleteUser({ dispatch, commit }, id){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/deleteUser/${id}`, method: 'DELETE' })
            .then(res => {
                commit('delete_user' , id)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }

}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
